/**
 * Rybbit analytics helper — cal.gem
 * Instance: https://rb.cl.geml.link
 */

type RybbitProperties = Record<string, string | number | boolean | string[]>;

declare global {
  interface Window {
    rybbit?: {
      event: (name: string, properties?: RybbitProperties) => void;
      pageview: () => void;
    };
  }
}

export function trackEvent(name: string, properties?: RybbitProperties) {
  if (typeof window === "undefined" || !window.rybbit) return;
  window.rybbit.event(name, properties);
}

export const rybbitEvents = {
  bookingConfirmed: (props: { eventTypeId?: number; isTeamBooking?: boolean; isEmbed?: boolean; isRescheduling?: boolean }) =>
    trackEvent("booking_confirmed", props),

  bookingCancelled: (props: { eventTypeId?: number }) =>
    trackEvent("booking_cancelled", props),

  bookingRescheduled: (props: { eventTypeId?: number }) =>
    trackEvent("booking_rescheduled", props),

  embedView: (props: { eventTypeId?: number }) =>
    trackEvent("embed_view", props),

  eventTypeViewed: (props: { eventTypeId?: number; eventSlug?: string; eventTitle?: string; eventLength?: number }) =>
    trackEvent("event_type_viewed", props),

  slotSelected: (props: { eventTypeId?: number; eventSlug?: string; slotTime?: string; eventLength?: number }) =>
    trackEvent("slot_selected", props),
};
